import React from 'react';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const Technology = () => {
  
  const location = useLocation();
  
  useEffect(()=>{
    const html = document.getElementsByTagName('html')[0];
    html.setAttribute('data-wf-page', '68603f7a056ff6f78f58cb6a');
    html.setAttribute('data-wf-site', '68603f7a056ff6f78f58cab1');
    window.Webflow && window.Webflow.destroy();
    window.Webflow && window.Webflow.ready();
    window.Webflow && window.Webflow.require('ix2').init();
    document.dispatchEvent(new Event('readystatechange'))
  },[])

   


  return(
      <>
    <div className="page-wrapper">
    <Navbar />
          <section class="section inner-banner">
      <div class="inner-banner-content">
        <div class="inner-banner-wrapper">
          <div class="container">
            <div class="inner-banner-typography">
              <div class="inner-banner-subtitle-wrap">
                <div class="inner-banner-subtitle">Technology</div>
              </div>
              <div class="inner-banner-title-wrapper">
                <h1 class="inner-banner-title technology">Secure network protocol for the next web.</h1>
                <p class="inner-banner-description">Fast &amp; secure blockchain platform for distributed apps,
                  enterprise use cases.</p>
              </div>
            </div>
          </div><img src="images/inner-20banner-20pluse-20icon.svg" loading="lazy" alt=""
            class="inner-banner-pluse-icon top-left" /><img src="images/inner-20banner-20pluse-20icon.svg"
            loading="lazy" alt="" class="inner-banner-pluse-icon top-right" /><img
            src="images/inner-20banner-20pluse-20icon.svg" loading="lazy" alt=""
            class="inner-banner-pluse-icon bottom-left" /><img src="images/inner-20banner-20pluse-20icon.svg"
            loading="lazy" alt="" class="inner-banner-pluse-icon bottom-right" />
        </div>
      </div>
    </section>
    <section class="section main-technology">
      <div class="container">
        <div class="main-technology-wrapper">
          <div data-w-id="4a513d34-7f50-9baa-9ba2-4a98877712a4" style={{ opacity: '1' }} class="technology-content">
            <div data-w-id="4a513d34-7f50-9baa-9ba2-4a98877712a5" class="technology-card-wrapper left">
              <div class="technology-card-typography">
                <div class="technology-card-title-description">
                  <h3 class="technology-card-title">Embrace the web3 infrastructure and beginning.</h3>
                  <p class="technology-card-description-text">Experience the Future of Blockchain &amp; Web3 – Unlock
                    the power of decentralization.</p>
                </div>
                <div class="technology-card-link-block-wrap"><a data-w-id="4a513d34-7f50-9baa-9ba2-4a98877712ad"
                    style={{ color: "rgb(255,255,255)" }} href="/technology" aria-current="page"
                    class="technology-card-link-block w-inline-block w--current">
                    <div style={{ borderColor: "rgb(255,255,255)" }} class="technology-card-link-block-name">Explore
                      technology</div>
                    <div
                      style={{ transform: "translate3d(0px, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)" }}
                      class="technology-card-link-block-icon"></div>
                  </a></div>
              </div>
              <div data-w-id="4a513d34-7f50-9baa-9ba2-4a98877712b2"
                class="technology-card-image-wrapper left-card-image">
                <div class="technology-card-image-single"><img src="images/technology-20card-20image1.webp"
                    loading="lazy" alt="" class="technology-card-image" /></div>
              </div>
            </div>
            <div data-w-id="4a513d34-7f50-9baa-9ba2-4a98877712b5" class="technology-card-wrapper right">
              <div class="technology-card-typography">
                <div class="technology-card-title-description">
                  <h3 class="technology-card-title">NFT &amp; Token Support – Empowering Digital Ownership.</h3>
                  <p class="technology-card-description-text">Multi-chain compatibility and cutting-edge blockchain
                    solutions.</p>
                </div>
                <div class="technology-card-link-block-wrap"><a data-w-id="4a513d34-7f50-9baa-9ba2-4a98877712bd"
                    style={{ color: "rgb(255,255,255)" }} href="/technology" aria-current="page"
                    class="technology-card-link-block w-inline-block w--current">
                    <div style={{ borderColor: "rgb(255,255,255)" }} class="technology-card-link-block-name">Explore
                      technology</div>
                    <div
                      style={{ transform: "translate3d(0px, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)" }}
                      class="technology-card-link-block-icon"></div>
                  </a></div>
              </div>
              <div data-w-id="4a513d34-7f50-9baa-9ba2-4a98877712c2"
                class="technology-card-image-wrapper right-card-image">
                <div class="technology-card-image-single"><img src="images/technology-20card-20image2.webp"
                    loading="lazy" alt="" class="technology-card-image" /></div>
              </div>
            </div>
          </div>
          <div data-w-id="8c35c8d6-d675-18c9-1938-c94208dbb9f7" style={{ opacity: '1' }} class="features-hv2-bottom-content">
            <div class="w-layout-grid features-hv2-grid">
              <div class="solving-card">
                <div class="solving-card-icon-wrapper"><img src="images/money-20power-20icon.svg" loading="lazy" alt=""
                    class="solving-card-icon" /></div>
                <div class="solving-card-title-description">
                  <h4 class="solving-card-title">Money Power</h4>
                  <p class="solving-card-description-text">Seamless, borderless transactions with decentralized finance
                    (DeFi), ensuring fast and secure digital payments.</p>
                </div><img src="images/features-20card-20shape-20top-20left.svg" loading="lazy" alt=""
                  class="solving-card-top-element" /><img src="images/features-20card-20shape-20bottom-20right.svg"
                  loading="lazy" alt="" class="solving-card-bottom-element" />
              </div>
              <div class="solving-card features-hv2">
                <div class="solving-card-icon-wrapper"><img src="images/solving-20card-20icon2.svg" loading="lazy"
                    alt="" class="solving-card-icon" /></div>
                <div class="solving-card-title-description">
                  <h4 class="solving-card-title">Ultimate Security</h4>
                  <p class="solving-card-description-text">Blockchain’s cryptographic security safeguards data
                    integrity, protecting users from fraud and cyber threats.</p>
                </div><img src="images/features-20card-20shape-20top-20left.svg" loading="lazy" alt=""
                  class="solving-card-top-element" /><img src="images/features-20card-20shape-20bottom-20right.svg"
                  loading="lazy" alt="" class="solving-card-bottom-element" />
              </div>
              <div class="solving-card features-hv2">
                <div class="solving-card-icon-wrapper"><img src="images/solving-20card-20icon3.svg" loading="lazy"
                    alt="" class="solving-card-icon" /></div>
                <div class="solving-card-title-description">
                  <h4 class="solving-card-title">Fair Governance</h4>
                  <p class="solving-card-description-text">Decentralized governance enables fair decision-making, giving
                    communities control over protocols and policies.</p>
                </div><img src="images/features-20card-20shape-20top-20left.svg" loading="lazy" alt=""
                  class="solving-card-top-element" /><img src="images/features-20card-20shape-20bottom-20right.svg"
                  loading="lazy" alt="" class="solving-card-bottom-element" />
              </div>
              <div class="solving-card">
                <div class="solving-card-icon-wrapper"><img src="images/solving-20card-20icon4.svg" loading="lazy"
                    alt="" class="solving-card-icon" /></div>
                <div class="solving-card-title-description">
                  <h4 class="solving-card-title">User Agency</h4>
                  <p class="solving-card-description-text">Users have full control over their digital assets,
                    identities, and interactions without reliance on intermediaries.</p>
                </div><img src="images/features-20card-20shape-20top-20left.svg" loading="lazy" alt=""
                  class="solving-card-top-element" /><img src="images/features-20card-20shape-20bottom-20right.svg"
                  loading="lazy" alt="" class="solving-card-bottom-element" />
              </div>
              <div class="solving-card">
                <div class="solving-card-icon-wrapper"><img src="images/solving-20card-20icon5.svg" loading="lazy"
                    alt="" class="solving-card-icon" /></div>
                <div class="solving-card-title-description">
                  <h4 class="solving-card-title">Reliable Systems</h4>
                  <p class="solving-card-description-text">Blockchain’s decentralized nature ensures uptime, preventing
                    single points of failure for uninterrupted services.</p>
                </div><img src="images/features-20card-20shape-20top-20left.svg" loading="lazy" alt=""
                  class="solving-card-top-element" /><img src="images/features-20card-20shape-20bottom-20right.svg"
                  loading="lazy" alt="" class="solving-card-bottom-element" />
              </div>
              <div class="solving-card features-hv2">
                <div class="solving-card-icon-wrapper"><img src="images/solving-20card-20icon6.svg" loading="lazy"
                    alt="" class="solving-card-icon" /></div>
                <div class="solving-card-title-description">
                  <h4 class="solving-card-title">Seamless Interoperability</h4>
                  <p class="solving-card-description-text">Bridging different blockchain networks, enabling seamless
                    data and asset exchange across multiple platforms.</p>
                </div><img src="images/features-20card-20shape-20top-20left.svg" loading="lazy" alt=""
                  class="solving-card-top-element" /><img src="images/features-20card-20shape-20bottom-20right.svg"
                  loading="lazy" alt="" class="solving-card-bottom-element" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section features">
      <div class="container">
        <div class="features-content">
          <div data-w-id="11fd1aad-2867-06d2-cf81-c01c4da43cbd" class="features-flex">
            <div class="features-typography-card top-border-none">
              <div class="features-typography-card-single">
                <div class="features-subtitle-wrapper">
                  <div class="features-subtitle">[ Integrations ]</div>
                </div>
                <div class="features-title-description">
                  <h2 class="features-title">Integration with existing blockchain networks.</h2>
                  <p class="features-description-text">Spend less time organizing and tracking, and more time on core
                    functions for your project Collaborate, manage projects.</p>
                </div>
                <div class="features-button-wrapper">
                  <div class="primary-button-wrapper"><a href="/pricing" class="inner-button w-inline-block">
                      <div class="primary-button-border-wrap">
                        <div class="inner-button-wrap">
                          <div class="inner-button-text-wrap">
                            <div class="inner-button-text">Get started</div>
                            <div class="inner-button-hover-text">Get started</div>
                          </div>
                          <div class="inner-button-star-wrap"><img loading="lazy" src="images/inner-button-star-1.svg"
                              alt="" class="inner-button-star _1" /><img loading="lazy"
                              src="images/inner-button-star-2.svg" alt="" class="inner-button-star _2" /><img
                              loading="lazy" src="images/inner-button-star-3.svg" alt="" class="inner-button-star _3" />
                          </div>
                          <div class="inner-button-hover-bg"></div>
                        </div>
                      </div>
                      <div class="line-wrap-inner">
                        <div class="inner-line-wrap _1">
                          <div class="line"></div>
                          <div class="line _2"></div>
                        </div>
                        <div class="inner-line-wrap _2">
                          <div class="line _3"></div>
                          <div class="line _4"></div>
                        </div>
                        <div class="inner-line-wrap _3">
                          <div class="line _5"></div>
                          <div class="line _6"></div>
                        </div>
                        <div class="inner-line-wrap _4">
                          <div class="line _7"></div>
                          <div class="line _8"></div>
                        </div>
                      </div>
                    </a></div>
                </div>
              </div><img src="images/features-20card-20shape-20top-20left.svg" loading="lazy" alt=""
                class="features-typography-card-shape top-left" /><img
                src="images/features-20card-20shape-20top-20right.svg" loading="lazy" alt=""
                class="features-typography-card-shape top-right" /><img
                src="images/features-20card-20shape-20bottom-20left.svg" loading="lazy" alt=""
                class="features-typography-card-shape bottom-left" /><img
                src="images/features-20card-20shape-20bottom-20right.svg" loading="lazy" alt=""
                class="features-card-shape-bottom-right" />
            </div>
            <div class="features-card-image-wrapper"><img src="images/features-20card-20image1.webp" loading="lazy"
                style={{opacity:"0"}} data-w-id="11fd1aad-2867-06d2-cf81-c01c4da43ce4" alt="" class="features-card-image" />
            </div>
          </div>
          <div data-w-id="11fd1aad-2867-06d2-cf81-c01c4da43ce5" class="features-flex">
            <div class="features-card-image-wrapper"><img src="images/features-20card-20image2.webp" loading="lazy"
                style={{opacity:"0"}} data-w-id="11fd1aad-2867-06d2-cf81-c01c4da43ce7" alt=""
                class="features-card-image two" /></div>
            <div class="features-typography-card">
              <div class="features-typography-card-single">
                <div class="features-subtitle-wrapper">
                  <div class="features-subtitle">[ Development ]</div>
                </div>
                <div class="features-title-description mb40">
                  <h2 class="features-title">Developing blockchain solution for business.</h2>
                  <p class="features-description-text">Many Web3 platforms are complex and have a steep learning curve,
                    discouraging new users from entering the space.</p>
                </div>
                <div class="features-list-wrapper">
                  <ul role="list" class="features-list">
                    <li class="features-list-item"><img src="images/features-20list-20item-20icon.svg" loading="lazy"
                        alt="" class="features-list-item-icon" />
                      <div class="features-list-item-text">Blockchain acts as the backbone for decentralization.</div>
                    </li>
                    <li class="features-list-item"><img src="images/features-20list-20item-20icon.svg" loading="lazy"
                        alt="" class="features-list-item-icon" />
                      <div class="features-list-item-text">Self-executing contracts written on a blockchain.</div>
                    </li>
                    <li class="features-list-item"><img src="images/features-20list-20item-20icon.svg" loading="lazy"
                        alt="" class="features-list-item-icon" />
                      <div class="features-list-item-text">The integration of Web3 with virtual worlds where users.
                      </div>
                    </li>
                  </ul>
                </div>
              </div><img src="images/features-20card-20shape-20top-20right.svg" loading="lazy" alt=""
                class="features-typography-card-shape top-right" /><img
                src="images/features-20card-20shape-20bottom-20left.svg" loading="lazy" alt=""
                class="features-typography-card-shape bottom-left" /><img
                src="images/features-20card-20shape-20bottom-20right.svg" loading="lazy" alt=""
                class="features-card-shape-bottom-right" /><img src="images/features-20card-20shape-20top-20left.svg"
                loading="lazy" alt="" class="features-typography-card-shape top-left" />
            </div>
          </div>
          <div data-w-id="11fd1aad-2867-06d2-cf81-c01c4da43d04" class="features-flex">
            <div class="features-typography-card">
              <div class="features-typography-card-single">
                <div class="features-subtitle-wrapper">
                  <div class="features-subtitle">[ Security ]</div>
                </div>
                <div class="features-title-description">
                  <h2 class="features-title">Most secured blockchain solutions.</h2>
                  <p class="features-description-text">Whether it’s an interview, or a meeting with hiring teams, you
                    can give your full attention to the conversation at hand.</p>
                </div>
                <div class="features-single-card">
                  <div class="features-single">
                    <div class="features-card-icon-wrap"><img src="images/features-20card-20icon1.svg" loading="lazy"
                        alt="" class="features-card-icon" /></div>
                    <div class="features-card-title-description">
                      <h4 class="features-card-title">Security</h4>
                      <p class="features-card-description">Reduce costs, scale effortlessly, &amp; make your business
                        come alive.</p>
                    </div>
                  </div>
                  <div class="features-single">
                    <div class="features-card-icon-wrap"><img src="images/features-20card-20icon2.svg" loading="lazy"
                        alt="" class="features-card-icon" /></div>
                    <div class="features-card-title-description">
                      <h4 class="features-card-title">Ethical Conduct</h4>
                      <p class="features-card-description">Committing to transparency in operations, transactions.</p>
                    </div>
                  </div>
                </div>
              </div><img src="images/features-20card-20shape-20top-20left.svg" loading="lazy" alt=""
                class="features-typography-card-shape top-left" /><img
                src="images/features-20card-20shape-20top-20right.svg" loading="lazy" alt=""
                class="features-typography-card-shape top-right" /><img
                src="images/features-20card-20shape-20bottom-20left.svg" loading="lazy" alt=""
                class="features-typography-card-shape bottom-left" /><img
                src="images/features-20card-20shape-20bottom-20right.svg" loading="lazy" alt=""
                class="features-card-shape-bottom-right" />
            </div>
            <div class="features-card-image-wrapper"><img src="images/features-20card-20image3.webp" loading="lazy"
                style={{opacity:"0"}} data-w-id="11fd1aad-2867-06d2-cf81-c01c4da43d25" alt=""
                class="features-card-image three" /></div>
          </div>
        </div>
      </div>
    </section>
    <section class="section development-section">
      <div class="container">
        <div class="development-wrapper">
          <div data-w-id="8ef8d513-1042-1931-8b64-424adab90b58" style={{ opacity: '1' }}
            class="core-features-section-title-wrapper">
            <div class="section-subtitle-wrapper">
              <div class="section-subtitle">[ Development ]</div>
            </div>
            <h2 class="section-title core-features">Developing blockchain solution for business.</h2>
          </div>
          <div data-w-id="d1c42c03-6c03-f69f-a754-6f4a2dbb1214" style={{ opacity: '1' }} class="development-main-wrapper">
            <div class="development-top-content">
              <div class="w-layout-grid development-grid">
                <div class="core-features-slider-card">
                  <div class="core-features-slider-card-image-wrap"><img
                      src="images/core-20features-20slider-20card-20image1.webp" loading="lazy" alt=""
                      class="core-features-slider-card-image" /></div>
                  <div class="core-features-card-title-description">
                    <h4 class="core-features-card-title">Data ownership &amp; monetization with decentralized exchanges.
                    </h4>
                    <p class="core-features-card-description-text">Blockchain acts as the backbone for decentralization.
                      It&#x27;s a secure and transparent distributed ledger system.</p>
                  </div><img src="images/features-20card-20shape-20top-20left.svg" loading="lazy" alt=""
                    class="core-features-slider-card-line top-left" /><img
                    src="images/features-20card-20shape-20top-20right.svg" loading="lazy" alt=""
                    class="core-features-slider-card-line top-right" /><img
                    src="images/features-20card-20shape-20bottom-20left.svg" loading="lazy" alt=""
                    class="core-features-slider-card-line bottom-left" /><img
                    src="images/features-20card-20shape-20bottom-20right.svg" loading="lazy" alt=""
                    class="core-features-slider-card-line bottom-right" />
                  <div class="core-features-slider-card-number">[ 01 ]</div>
                </div>
                <div class="core-features-slider-card">
                  <div class="core-features-slider-card-image-wrap"><img
                      src="images/core-20features-20slider-20card-20image2.webp" loading="lazy" alt=""
                      class="core-features-slider-card-image" /></div>
                  <div class="core-features-card-title-description">
                    <h4 class="core-features-card-title _2nd">Immutable data storage and encryption services.</h4>
                    <p class="core-features-card-description-text">Cryptocurrencies like Bitcoin and Ether are native to
                      the Web3 ecosystem and can be used for various purposes.</p>
                  </div><img src="images/features-20card-20shape-20top-20left.svg" loading="lazy" alt=""
                    class="core-features-slider-card-line top-left" /><img
                    src="images/features-20card-20shape-20top-20right.svg" loading="lazy" alt=""
                    class="core-features-slider-card-line top-right" /><img
                    src="images/features-20card-20shape-20bottom-20left.svg" loading="lazy" alt=""
                    class="core-features-slider-card-line bottom-left" /><img
                    src="images/features-20card-20shape-20bottom-20right.svg" loading="lazy" alt=""
                    class="core-features-slider-card-line bottom-right" />
                  <div class="core-features-slider-card-number">[ 02 ]</div>
                </div>
              </div>
            </div>
            <div class="development-bottom-content">
              <div class="core-features-slider-card">
                <div class="core-features-slider-card-image-wrap"><img
                    src="images/core-20features-20slider-20card-20image3.webp" loading="lazy" alt=""
                    class="core-features-slider-card-image" /></div>
                <div class="core-features-card-title-description">
                  <h4 class="core-features-card-title _3rd">Strategy formulation for blockchain adoption</h4>
                  <p class="core-features-card-description-text">Leverage partnerships or innovative solutions to
                    provide users with competitive interest rates and lower transaction fees.</p>
                </div><img src="images/features-20card-20shape-20top-20left.svg" loading="lazy" alt=""
                  class="core-features-slider-card-line top-left" /><img
                  src="images/features-20card-20shape-20top-20right.svg" loading="lazy" alt=""
                  class="core-features-slider-card-line top-right" /><img
                  src="images/features-20card-20shape-20bottom-20left.svg" loading="lazy" alt=""
                  class="core-features-slider-card-line bottom-left" /><img
                  src="images/features-20card-20shape-20bottom-20right.svg" loading="lazy" alt=""
                  class="core-features-slider-card-line bottom-right" />
                <div class="core-features-slider-card-number">[ 03 ]</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section data-w-id="1c3f6ead-2444-a223-fec9-b2e0c543d72e" class="section cta">
      <div class="container">
        <div class="cta-content">
          <div data-w-id="1c3f6ead-2444-a223-fec9-b2e0c543d731" class="cta-typography">
            <div class="cta-title-description">
              <h2 class="cta-title">Embrace the future of Web3 and Blockchain.</h2>
              <p class="cta-description-text">Highly scalable, fast and secure blockchain platform for distributed apps,
                enterprise use cases.</p>
            </div>
            <div class="cta-button-wrapper">
              <div class="primary-button-wrapper"><a href="/pricing" class="inner-button w-inline-block">
                  <div class="primary-button-border-wrap">
                    <div class="inner-button-wrap">
                      <div class="inner-button-text-wrap">
                        <div class="inner-button-text">Get started now</div>
                        <div class="inner-button-hover-text">Get started now</div>
                      </div>
                      <div class="inner-button-star-wrap"><img loading="lazy" src="images/inner-button-star-1.svg"
                          alt="" class="inner-button-star _1" /><img loading="lazy" src="images/inner-button-star-2.svg"
                          alt="" class="inner-button-star _2" /><img loading="lazy" src="images/inner-button-star-3.svg"
                          alt="" class="inner-button-star _3" /></div>
                      <div class="inner-button-hover-bg"></div>
                    </div>
                  </div>
                  <div class="line-wrap-inner">
                    <div class="inner-line-wrap _1">
                      <div class="line"></div>
                      <div class="line _2"></div>
                    </div>
                    <div class="inner-line-wrap _2">
                      <div class="line _3"></div>
                      <div class="line _4"></div>
                    </div>
                    <div class="inner-line-wrap _3">
                      <div class="line _5"></div>
                      <div class="line _6"></div>
                    </div>
                    <div class="inner-line-wrap _4">
                      <div class="line _7"></div>
                      <div class="line _8"></div>
                    </div>
                  </div>
                </a></div>
            </div>
          </div><img src="images/features-20card-20shape-20top-20left.svg" loading="lazy" alt=""
            class="cta-top-left-element" /><img src="images/features-20card-20shape-20top-20right.svg" loading="lazy"
            alt="" class="cta-top-right-element" /><img src="images/cta-20botton-20left-20element.svg" loading="lazy"
            alt="" class="cta-bottom-left-element" /><img src="images/cta-20botton-20right-20element.svg" loading="lazy"
            alt="" class="cta-bottom-right-element" /><img src="images/cta-20shape.webp" loading="lazy"
            data-w-id="1c3f6ead-2444-a223-fec9-b2e0c543d752" sizes="(max-width: 537px) 100vw, 537px" alt=""
            srcset="images/cta-2520shape-p-500.png 500w, images/cta-20shape.webp 537w" class="cta-shape" /><img
            src="images/cta-20elment1.webp" loading="lazy" data-w-id="1c3f6ead-2444-a223-fec9-b2e0c543d753" alt=""
            class="cta-elment-one" /><img src="images/cta-20elment2.webp" loading="lazy"
            data-w-id="1c3f6ead-2444-a223-fec9-b2e0c543d754" alt="" class="cta-elment-two" />
        </div>
      </div>
    </section>
    <Footer />
    </div>
  </>
  )

};

export default Technology; 